import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { PaymentStatus, paymentStatusColors } from '@modules/universal-billing/accounting/payments/payment.enum';
import { TranslateService } from '@ngx-translate/core';

@Directive({
  selector: '[paymentStatusBadge]',
  standalone: true
})
export class PaymentStatusBadgeDirective implements OnInit {
  @Input('type') paymentStatus!: PaymentStatus;

  constructor(private el: ElementRef, private renderer: Renderer2, private translate: TranslateService) {}

  ngOnInit(): void {
    this.updateBadge();
  }

  private updateBadge(): void {

    const badgeClass = paymentStatusColors[this.paymentStatus];
    const label = this.translate.instant('PAYMENT.STATUSES.' + this.paymentStatus);


    this.renderer.setProperty(this.el.nativeElement, 'innerHTML', '');

    this.renderer.addClass(this.el.nativeElement, 'badge');
    this.renderer.addClass(this.el.nativeElement, badgeClass);


    this.el.nativeElement.innerText = label;
  }
}
